'use client';

import { useEffect, useState } from 'react';

/**
 * Задержка значения.
 *
 * Нужна поиску: он ходит на сервер, и запрос на каждую букву — это и лишняя
 * нагрузка, и мелькающий список под руками у пользователя.
 */
export function useDebounced<T>(value: T, delayMs = 350): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
